import MariConsole from "../components/MariConsole";

export default function MariPage() {
  return (
    <MariConsole baseUrl={process.env.REACT_APP_BACKEND_URL} subtitle="Official AI brain · full platform control"
      placeholder="Ask MARI anything, or tell her what to do…" height={440} />
  );
}
